<!--
 * @Author: lijiahui
 * @Date: 2020-02-18 10:48:02
 * @LastEditTime: 2020-02-24 16:29:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\activity\app_donation_active\userLogin.vue
 -->
<template>
  <div class="loginWrap">
    <div class="login" v-show="loginShow">
      <div class="top">
        <img src="../../../assets/images/activity/donationActive/login_logo.png" alt="" class="home">
      </div>
      <div class="bottom">
        <div class="phone_box">
          <div class="areaNum">+86</div>
          <input type="number" max="11" @input="phoneReg" placeholder="输入手机号" class="phone" v-model="phoneNum" @blur="onBlur">
        </div>
        <div class="code_box">
          <span class="getCode" v-show="!getCodeShow" @click="getCodeFn">获取验证码</span>
          <span class="getCodeTime" v-show="getCodeShow">
            <van-count-down ref="countDown" millisecond :time="60000" :auto-start="false" format="ss" @finish="countFinished" />秒后再次发送
          </span>
          <input type="number" max="6" @input="phoneCodeReg" placeholder="输入6位验证码" class="phoneCode" v-model="phoneCode" @blur="onBlur">
        </div>
      </div>
      <button @click="confrim" class="btn">查询我的信息</button>
    </div>
    <activity-result v-show="resultShow" :resultCode="resultCode" :channelName="channelName" :pageSource="pageSource" @userAgainWrite="againWrite" @goBack="toBack"></activity-result>
    <activity-result-App v-show="userCommitShow" :commitShow='commitShow' :channelName="channelName" :pageSource="pageSource" @userAgainWrite="againWrite" @goBack="toBack"></activity-result-App>
  </div>
</template>


<style lang="less" scoped>
.loginWrap {
  background: @expertFontColor255;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99;
  .login {
    background: @expertFontColor255;
    width: 100%;
    height: 100%;
    .top {
      .home {
        padding: 52px 0 62px 116px;
        height: 70px;
        width: 130px;
      }
    }
    .bottom {
      position: relative;
      .phone_box {
        margin: 0 31px 37px 31px;
        border-bottom: 1px solid #f2f2f2;
        overflow: hidden;
        .areaNum {
          color: #333;
          font-size: @indexFontSize14;
          font-weight: bold;
          display: inline-block;
          // position: absolute;
          // left: 31px;
          // top: 1px;
        }
        .phone {
          border: none;
          padding: 0 0 13px 35px;
          width: 50%;
          height: 20px;
          font-size: @indexFontSize16;
        }
      }
      .code_box {
        margin: 0 31px 55px 31px;
        overflow: hidden;
        border-bottom: 1px solid #f2f2f2;
        .phoneCode {
          border: none;
          padding-bottom: 13px;
          width: 50%;
          height: 20px;
          font-size: @indexFontSize16;
        }
        .getCode {
          color: #203dab;
          font-size: @indexFontSize14;
          position: absolute;
          right: 50px;
          top: 68px;
          font-weight: bold;
        }
        .getCodeTime {
          color: @expertFontColor153;
          font-size: @indexFontSize14;
          position: absolute;
          right: 50px;
          top: 68px;
          .van-count-down {
            color: @expertFontColor153;
            font-size: @indexFontSize14;
            margin-top: 1px;
            float: left;
          }
        }
        ::-webkit-input-placeholder {
          color: #999;
          font-size: @indexFontSize16;
        }
      }
    }
    .btn {
      background: linear-gradient(
        -90deg,
        rgba(32, 61, 171, 1),
        rgba(39, 76, 213, 1)
      );
      width: 80%;
      height: 51px;
      border-radius: 10px;
      border: none;
      margin: 0 40px 0 35px;
      color: @expertFontColor255;
      font-size: @indexFontSize18;
      line-height: 36px;
    }
    .info {
      margin: 23px 0 0 42px;
      font-size: @indexFontSize12;
      color: #999;
      .textBlue {
        color: #469eff;
      }
    }
  }
}
</style>


<script>
import { getCookie, is_weixin, Debounce } from '@/assets/js/common.js'
import API from "@/utils/axiosApi/donationApi";
import activityResult from "@/components/activity/donation_active/activityResult.vue";
import activityResultApp from "@/components/activity/donation_active/activityResultApp.vue";
import channelData from './../../../utils/mockData/channelData';
import wxJsSet from './../../../assets/js/DonatewxConfig.js'
export default {
  data () {
    return {
      phoneNum: '',// 手机号
      phoneCode: '', // 验证码
      addUserInfo: [], // 注册信息
      userOpenid: '',
      fromPath: '', fromName: '',
      getCodeShow: false,
      userNickName: '',  // 用户昵称 
      loginFlag: true,
      UserInfo: '',
      loginShow: false,
      resultShow: false,
      resultCode: null,
      channelName: "",
      pageSource: null,
      userCommitShow: false, // 手机号未提交过申请
      commitShow: false,
      userShow: false,
    }
  },
  components: {
    activityResult, activityResultApp
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.is_weixin()) {
        if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {//判断有没有openId
          location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
        } else {
          vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
          if (!vm.UserInfo || vm.UserInfo == "" || !vm.UserInfo.mobile || vm.UserInfo.mobile == "") {
            vm.$http.post('/starMom/getUser', {}, { openId: vm.getCookie("xmh_openid") }, res => {
              if (res.code == "200") {
                vm.UserInfo = res.data;
                vm.phoneNum = vm.UserInfo.mobile
                vm.getUserOrder()
              } else if (res.code == "500") {
                vm.loginShow = true
              }
            })
          } else {
            vm.phoneNum = vm.UserInfo.mobile
            vm.getUserOrder()
          }
        }
      } else {
        vm.UserInfo = JSON.parse(localStorage.getItem('userInfo'));
        if (!vm.UserInfo || vm.UserInfo == "" || !vm.UserInfo.mobile || vm.UserInfo.mobile == "") {
          vm.$http.post('/starMom/getUser', {}, { openId: vm.getCookie("xmh_openid") }, res => {
            if (res.code == "200") {
              vm.UserInfo = res.data;
              vm.phoneNum = vm.UserInfo.mobile
              vm.getUserOrder()
            } else if (res.code == "500") {
              vm.loginShow = true
            }
          })
        } else {
          vm.phoneNum = vm.UserInfo.mobile
          vm.getUserOrder()
        }
      }
    })
  },
  mounted () {
    if (this.$route.query.pageSource) {
      this.pageSource = this.$route.query.pageSource;
      this.channelName = channelData.channelLogoAppList[this.pageSource];
      this.channelQcode = "https://image-mom.feihe.com/channelQcode/" + this.$route.query.pageSource + ".jpg";
      if (this.pageSource.indexOf("_wx") !== -1) {
        this.isWeixin = "weixin";
      } else if (this.pageSource.indexOf("_app") !== -1) {
        this.isWeixin = "app";
      }
    }
    var shareLink = location.origin + "/donationMilk";
    var that = this;
    var shareDataParams = {
      shareLink: shareLink,
      shareDesc: '中国飞鹤累计捐赠2亿元款物。点击领取',
      shareTitle: '飞鹤直送一亿奶粉，孕妈领取专属免疫力',
      imgUrl: "https://image-mom.feihe.com/wxshare/donation.png",//必须是绝对路径
      shareSuccess: function () {
        that.$toast({
          duration: 2000,
          message: '分享成功'
        })
      }
    }
    wxJsSet.wxShare(this, shareDataParams);
  },
  methods: {
    onBlur () {
      $(window).scrollTop(0)
    },
    // 获取验证码
    getCodeFn () {
      if (this.phoneNum == "") {
        this.$toast({
          message: '请输入手机号',
          forbidClick: true,
          duration: 2000,
          context: this
        })
      } else {
        // this.$http.hostName+
        this.$http.get(`${this.$http.hostName}/activity/common/sendVerificationCode`, { phone: this.phoneNum }, res => {
          if (res.code === "200") {
            this.getCodeShow = true;
            this.$refs.countDown.start();
            this.$toast({
              message: '发送成功',
              forbidClick: true,
              duration: 2000,
              context: this
            })
          } else {
            this.$toast({
              message: res.message,
              forbidClick: true,
              duration: 2000,
              context: this
            });
          }
        })
      }
    },
    countFinished: function () {
      this.getCodeShow = false;
      this.$refs.countDown.reset();
    },
    // 校验手机号
    phoneReg: function () {
      var isPhone = /^1[3456789]\d{9}$/;//手机号码
      this.phoneNum = this.phoneNum.replace(/[^\d]/g, '');
      this.phoneNum = this.phoneNum.replace(/[, ]/g, '');
      this.phoneNum = this.phoneNum.substring(0, 11);
      if (this.phoneNum != "" && this.phoneNum.length == 11) {
        if (!isPhone.test(this.phoneNum)) {
          this.$toast({
            duration: 2000,
            message: "请输入正确的手机号",
            forbidClick: true,
            context: this
          })
        }
      }
    },
    // 校验验证码
    phoneCodeReg: function () {
      var isphoneCode = /^[0-9]*$/;
      this.phoneCode = this.phoneCode.replace(/[^\d]/g, '');
      this.phoneCode = this.phoneCode.replace(/[, ]/g, '');
      this.phoneCode = this.phoneCode.substring(0, 6);
      if (this.phoneCode != "" && this.phoneCode.length == 6) {
        if (!isphoneCode.test(this.phoneCode)) {
          this.$toast({
            duration: 2000,
            message: "请输入正确的验证码",
            forbidClick: true,
            context: this
          })
        }
      }
    },
    // 点击确定登录
    confrim: Debounce(function () {
      if (!this.loginFlag) return false;
      this.loginFlag = false;
      if (this.phoneNum == "" || this.phoneCode == "") {
        this.$toast({
          message: '请输入手机号和验证码',
          forbidClick: true,
          duration: 2000,
          context: this
        });
        return false;
      } else {
        if (this.is_weixin()) {
          // 微信环境
          this.userOpenid = this.getCookie('xmh_openid')
          API.bindPhoneAndOpenId({}, { code: this.phoneCode, mobile: this.phoneNum, openId: this.userOpenid }, res => {
            if (res.code == '200') {
              this.getUserOrder()
              this.loginFlag = true;
            } else if (res.code == '501') {
              this.$toast({
                message: "绑定失败，该手机号已绑定其他微信号",
                forbidClick: true,
                duration: 2000,
                context: this
              })
              this.loginFlag = true;
            } else {
              this.$toast({
                message: res.message,
                forbidClick: true,
                duration: 2000,
                context: this
              })
              this.loginFlag = true;
            }
            this.loginFlag = true;
          })
          this.loginFlag = true;
        } else {
          this.userOpenid = this.getCookie('xmh_openid')
          API.bindPhoneAndOpenId({}, { code: this.phoneCode, mobile: this.phoneNum, openId: this.userOpenid }, res => {
            if (res.code == '200') {
              this.getUserOrder()
            }
            this.loginFlag = true;
          })
          this.loginFlag = true;
        }
      }
    }, 500),
    // 获取用户订单状态
    getUserOrder () {
      this.$http.post("/donate/checkStatus/", {}, { mobile: this.phoneNum }, res => {
        if (res.code == '205') {
          this.$router.push({ path: "/donationMilkApp/userInfoSearch" });
        } else if (res.code == "201" || res.code == "202" || res.code == "203" || res.code == "204") {
          this.resultCode = res.code;
          this.loginShow = false;
          this.resultShow = true;
        } else {
          this.loginShow = false;
          this.userCommitShow = true;
          this.commitShow = true
        }
      })
    },
    // 用户状态为203时，点击重新填写
    againWrite () {
      this.$toast({
        duration: 4000,
        message: '您好，申领活动已结束'
      })
      // if(new Date().getHours()<9){
      //     this.$toast({
      //         duration:4000,
      //         message:'9点限量开放，先到先得！'
      //     })
      // }else if(new Date().getHours()>=9 && new Date().getHours()<15){ //9点到下午15点
      //     this.checkCount("今日上午已达上限，信息无法提交。\n下午15点限量开放，先到先得！");
      // }else{
      //     this.checkCount("您好，申领活动已结束");
      // }
    },
    checkCount (message) {
      // 9点之后
      this.$http.get("/donate/countMember", {}, res => {
        if (!res.data) {
          this.$toast({
            duration: 4000,
            message: message
          })
        } else {
          this.$router.push({ path: "/donationMilk/userInfo?isAgain=true" });
          gio('track', "donationmilk_reapply", { "pageSource_var": "星妈会", "isWeixin": "weixin" });//捐奶粉活动-重新gio埋点
        }
      }, error => {
        this.$toast({
          duration: 2000,
          message: '活动太火爆了，请稍后重试。'
        })
      })
    },
    // 返回上一页
    toBack () {
      if (this.pageSource) {
        location.href = "/donationMilk?pageSource=" + this.pageSource;
      } else {
        location.href = "/donationMilk";
      }
    },
    getFromPath: function (fromPath, fromName) {
      this.fromPath = fromPath;
      this.fromName = fromName;
    },
    getCookie, is_weixin, Debounce
  }
}
</script>
